import React, { useLayoutEffect } from 'react'
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../../common/resource/proptypes/CommonPropTypes';
import { clearBoardingGroup, getBoardingGroup } from '../../../../../actions/itinerary/BoardingGroup';
import { BOARDING_GROUP_PATH } from '../../../../../config/paths';
import Loader from '../../../../common/Loader';
import Content from '../../../../layout/Content';
import NoDataResource from '../../../../common/resource/NoDataResource';
import BoardingGroupBasicInformationResource from './BoardingGroupBasicInformationResource';
import BoardingGroupToolbar from './BoardingGroupToolbar';

const BoardingGroup = ({
  breadcrumbs,
  boardingGroup,
  loading,
  dispatchGetBoardingGroup,
  dispatchClearBoardingGroup,
  match: {
    params: { id: boardingGroupId },
  },
}) => {
  useLayoutEffect(() => {
    dispatchGetBoardingGroup({ boardingGroupId });
    return () => dispatchClearBoardingGroup();
  }, []);

  let content;
  let toolbar;

  if (loading) content = <Loader />;
  else if (boardingGroup.isEmpty())
    content = <NoDataResource returnPage={BOARDING_GROUP_PATH} />;
  else {
    const boardingGroupJson = boardingGroup.toJS();

    content = <BoardingGroupBasicInformationResource {...boardingGroupJson} />;

    toolbar = <BoardingGroupToolbar boardingGroupId={boardingGroupJson.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      toolbar={toolbar}
      title="Grupo de Embarque"
      content={content}
    />
  )
}

BoardingGroup.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  boardingGroup: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  dispatchGetBoardingGroup: PropTypes.func.isRequired,
  dispatchClearBoardingGroup: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

BoardingGroup.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Grupo de Embarques',
      href: BOARDING_GROUP_PATH,
    },
    {
      text: 'Ver',
      href: `${BOARDING_GROUP_PATH}/:id`,
    },
  ],
  boardingGroup: ItineraryUnit.BoardingGroup.getIn(['current', 'content']),
  loading: !ItineraryUnit.BoardingGroup.getIn(['current', 'activity']).isEmpty(),
})

const mapDispatchToProps = {
  dispatchGetBoardingGroup: getBoardingGroup,
  dispatchClearBoardingGroup: clearBoardingGroup,
}

export default connect(mapStateToProps, mapDispatchToProps)(BoardingGroup);